import * as React from "react";

import ContractForm from "../../../components/Forms/ServiceContract/ContractForm/FlowForm";

export default function ServiceContractCreate() {
  return <ContractForm />;
}
